import React from 'react';
import css from './OverlayExternalLink.module.css';
import tmLogo from '../../assets/censo/tm.svg';

const OverlayExternalLink = (props) => {

    const { url, overlayHidden, setOverlayHidden } = props;

    return (
        <div className={css.externalLinkOverlay}>
            <div className={css.overlayContent}>
                <div className={css.logoContainer}>
                    <img src={tmLogo} alt="Todo Motorhome Logo" className={css.logo} />
                </div>
                <h2 className={css.overlayTitle}>Enlace Externo</h2>
                <p className={css.overlayDescription}>Estás a punto de salir de nuestro sitio. ¿Deseas continuar?</p>
                <div className={css.buttonContainer}>
                    <button className={css.cancelButton} onClick={() => setOverlayHidden(false)}>Cancelar</button>
                    <button className={css.continueButton} onClick={() => window.open(url, '_blank')}>Continuar</button>
                </div>
            </div>
        </div>
    );
};

export default OverlayExternalLink;